import React, { useEffect, useRef, useMemo } from 'react';
import styles from './css/index.module.css';

import { Dismiss16Regular } from '@fluentui/react-icons';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineClose } from 'react-icons/ai';
import { validExtensions } from '../../utils/misc';
import { uploadFilesWithProgressTray } from '../../utils/uploadFilesWithProgressTray';

const AddDocumentModal = ({ setUploadDocumentSidebar, setShowSidebar, selectedFolders, workstream, NavigationMenuFolders }) => {
    const selectedFolder = useMemo(() => {
        return selectedFolders?.length > 0 ? selectedFolders[selectedFolders.length - 1] : {};
    }, [selectedFolders]);
    const [uploadedFiles, setUploadedFiles] = React.useState([]);
    const fileInputRef = useRef();
    const { selectedProject } = useSelector(state => state?.projectData);
    const { projectUsersAll } = useSelector(state => state?.team);
    const { user } = useSelector(state => state?.user);
    const [buttonLoading, setButtonLoading] = React.useState(false);
    const dispatch = useDispatch();
    const handleDivClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = e => {
        const selectedFiles = e.target.files;
        setUploadedFiles(Array.from(selectedFiles));
    };
    const handleDrop = e => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        setUploadedFiles(Array.from(files));
    };

    const handlePaste = e => {
        const items = e.clipboardData.items;
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.kind === 'file') {
                item.getAsFile();
            }
        }
    };

    const handleAddFile = async () => {
        setButtonLoading(true);
        const uploadBy =
            selectedProject?.vdr?.vdr_admin !== user?.id
                ? projectUsersAll?.find(projectUser => projectUser?.value?.user_id === user?.id)?.value?.group_member_id
                : undefined;

        await uploadFilesWithProgressTray({
            dispatch,
            files: uploadedFiles,
            folder: selectedFolder,
            workstreamId: workstream?.id,
            projectId: selectedProject?.id,
            vdrId: selectedProject?.vdr?.id,
            uploadBy,
        });

        setButtonLoading(false);
        handleClose();
    };
    const handleClose = () => {
        setUploadedFiles([]);
        setShowSidebar(false);
        setUploadDocumentSidebar(false);
    };
    useEffect(() => {
        const div = document.getElementById('uploadDiv');
        if (div) {
            div.addEventListener('dragover', e => e.preventDefault());
            div.addEventListener('drop', handleDrop);
            div.addEventListener('paste', handlePaste);

            return () => {
                div.removeEventListener('dragover', e => e.preventDefault());
                div.removeEventListener('drop', handleDrop);
                div.removeEventListener('paste', handlePaste);
            };
        }
    }, []);

    return (
        <div className={styles.sidebarWhite}>
            <div className="d-flex align-items-center justify-content-between mb-5">
                <h5 className={styles.sidebarTitle}>Upload Files</h5>
                <Dismiss16Regular onClick={handleClose} role="button" color="var(--Neutral-Gray-6)" />
            </div>
            <div className=" mb-4 ">{NavigationMenuFolders}</div>
            {uploadedFiles?.length > 0 ? (
                <div className={styles.uploadItemsList}>
                    {uploadedFiles?.map(item => (
                        <div className={styles.fileListItem} key={item?.name}>
                            <span>{item?.name}</span>
                            <AiOutlineClose size={14} onClick={() => setUploadedFiles(uploadedFiles?.filter(file => file?.name !== item?.name))} />
                        </div>
                    ))}
                </div>
            ) : (
                <div id="uploadDiv" className={styles.uploadBox} onClick={handleDivClick}>
                    <span>
                        Drag & Drop Files or <br /> Click to Upload
                    </span>
                    <input multiple type="file" accept={validExtensions.join(',')} ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
                </div>
            )}

            <button disabled={buttonLoading || uploadedFiles?.length === 0} onClick={handleAddFile} className={styles.saveButton}>
                Save
            </button>
        </div>
    );
};

export default AddDocumentModal;
